import { BAR_GRADIENT } from '@/charts/Chart/constants';
import type { BarChartOptions, ComparisonRole } from './types';

export const CHIP_LIFT = 18;

export const CHIP_HEADROOM = 1.3;

export const CHIP_FILL_TOLERANCE = 1.1;

export const CHIP_TICKS = { min: 3, max: 5 };

// Ordered by preference: a 2 or 5 step beats a 3 or 8 step at similar fill
export const NICE_STEPS = [1, 2, 5, 4, 3, 6, 8];

export const PAIRED_BARS: Pick<
  BarChartOptions,
  'columnWidth' | 'barRadius' | 'barGap'
> = {
  columnWidth: '70%',
  barRadius: 6,
  barGap: 4,
};

export const FLOATING_LABELS: Pick<
  BarChartOptions,
  'dataLabelsPosition' | 'dataLabelChips'
> = {
  dataLabelsPosition: 'top',
  dataLabelChips: true,
};

export const COMPARISON_BARS: Pick<
  BarChartOptions,
  | 'hideZeroLabels'
  | 'legend'
  | 'animations'
  | 'columnWidth'
  | 'barRadius'
  | 'barGap'
  | 'dataLabelsPosition'
  | 'dataLabelChips'
> = {
  hideZeroLabels: true,
  legend: false,
  animations: false,
  ...PAIRED_BARS,
  ...FLOATING_LABELS,
};

export const COMPARISON_GRADIENT: Record<
  ComparisonRole,
  (typeof BAR_GRADIENT)['brand']
> = {
  current: BAR_GRADIENT.brand,
  previous: BAR_GRADIENT.teal,
};
